import { render } from "./SitesList.vue?vue&type=template&id=25a72542"
import script from "./SitesList.vue?vue&type=script&lang=js"
export * from "./SitesList.vue?vue&type=script&lang=js"

import "./SitesList.vue?vue&type=style&index=0&id=25a72542&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__